// Modern ES6+ imports
console.log("📁 Script file loaded");

import { gsap } from "gsap";
import { Splide } from "@splidejs/splide";
import { Video } from "@splidejs/splide-extension-video";
import anime from "animejs";
import Accordion from "accordion-js";
import GLightbox from "glightbox";
import intlTelInput from "intl-tel-input";

// Import modules
// import { Phonenumber } from "./phonenumber.js";
import { initAnimations, initBarMarquee } from "./modules/animations.js";
import { initSliders } from "./modules/sliders.js";
import { initAccordions } from "./modules/accordions.js";
import { initTabs } from "./modules/tabs.js";
// import { initLightbox } from "./modules/lightbox.js";
import { initVideoPopup } from "./modules/video-popup.js";
import { initSearchHeader } from "./modules/search.js";
import { initDownloadLinks } from "./modules/downloads.js";
import { initModal } from "./modules/modal.js";
// import { initIntl } from "./modules/intl-phone.js";
// import { initCarousel } from "./modules/carousel.js";
import { initMoreContent, initCardAboutBrand, initTrustedLoadMore } from "./modules/content.js";
import { initNewsCategories } from "./modules/news-categories.js";
import { initMobileClick, initMobileSidebarTabs, initScrollHeader } from "./modules/mobile.js";
import { initNavigation } from "./modules/navigation.js";
import { initProductFeatured } from "./modules/product-featured.js";
import { initActivationQuiz } from "./modules/activation-quiz.js";
import { initMomenGallery, initMomenGallerySimple } from "./modules/momen-gallery.js";
import { initDropdownSelect, initFormSelectActive } from "./modules/forms.js";
import { watchGTranslate } from "./modules/gtranslate.js";

// Your main app
class TongkolspaceApp {
  constructor() {
    console.log("🚀 Tongkolspace App Initialized");
    this.init();
  }

  init() {
    // Initialize all modules
    initAnimations();
    initBarMarquee();
    initSliders();
    initAccordions();
    initTabs();
    // initLightbox();
    initNavigation();
    initVideoPopup();
    initSearchHeader();
    initDownloadLinks();
    initModal();
    // initCarousel();
    // initMobileSidebarTabs();
    // initIntl();
    // initCardAboutBrand();
    initMoreContent();
    initTrustedLoadMore();
    initMobileClick();
    initScrollHeader();
    initProductFeatured();
    initActivationQuiz();
    initMomenGallery();
    initMomenGallerySimple();
    initFormSelectActive();
    initDropdownSelect();
    initNewsCategories();
    watchGTranslate();

    // Initialize phonenumber
    // this.initPhonenumber();
  }

  // initPhonenumber() {
  //   const phoneApp = new Phonenumber();
  // }
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  new TongkolspaceApp();
});

// Export for global access if needed
window.TongkolspaceApp = TongkolspaceApp;
